import type { ComponentEnhancer } from 'recompose';
import type { TMicroApps } from '../Auth';

import { usePageLoadPerformance } from '@mindtickle/ui-shell-core/PerformanceMetrics';

const withPerformanceData = <P extends {}>({ appName }: { appName: TMicroApps }) => {
  const enhancer = (Component: React.FunctionComponent<P>) => (props: P) => {
    usePageLoadPerformance({ appName });

    return <Component {...props} />;
  };
  return (enhancer as unknown) as ComponentEnhancer<P, P>;
};

export default withPerformanceData;
